import React, { Component } from "react";
import "./GeoCode.css";
import { toAbsoluteUrl } from "../../../../../theme/utils/utils";
class GeoCoding extends Component {


  constructor(props) {
    super(props);
    this.state = {
      lat: 0,
      lng: 0,
      fullAddress: props.address
    };
    this.getGeoCoding(props.address);
    this.sendParentData = this.sendParentData.bind(this);
  }


  addressInputHandler = event => {
    this.setState({ address: event.target.value });
  };

  getGeoCoding = address => {
    console.log(address);

    fetch(
      "https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyCzYy4yif1EK2nk6S0cufJy2LKxXK8_i38&region=IN&address=" +
      encodeURI(address.replace('#','%23')),
    )
      .then(data => data.json())
      .then(resp => {
        if(resp.status === "ZERO_RESULTS") {
			 this.setState({ lat: '', lng: '' });
			this.sendParentData(this.state);
			this.renderMap();
		 }
		 else {
			const { lat, lng } = resp.results[0].geometry.location;
			this.setState({ lat: lat, lng: lng });
			this.sendParentData(this.state);
			this.renderMap();
		 }
      })
      .catch(err => console.log(err));
  };

  sendParentData(data) {
    this.props.callbackFromParent(data)
  }


  getReverseGeoCoding = (lat, lng) => {
    console.log(lat + "-----" + lng);

    fetch(
      "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
      lat + "," + lng +
      "&key=AIzaSyCzYy4yif1EK2nk6S0cufJy2LKxXK8_i38&region=IN",
      {
        method: "GET",

        credentials: "same-origin"
      }
    )
      .then(data => data.json())
      .then(resp => {
        // const { lat, lng } = resp.results[0].geometry.location;
        this.setState({ fullAddress: resp.results[0].formatted_address });
        // this.renderMap();
        this.sendParentData(this.state);
        console.log(this.state)
        console.log(resp.results[0].address_components);
      })
      .catch(err => console.log(err));
  };
  renderMap = () => {
    loadScript(
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBBTbZ_U1tJKRL_GPdrIm5ecJsUFH9T0Wk&callback=initMap"
    );
    window.initMap = this.initMap;
  };

  setGeoCode = (lat, lng) => {
    console.log("inside setGeoCode");
    console.log(lat);
  };
  initMap = () => {
    var myLatlng;
    var mapOptions;
    myLatlng = new window.google.maps.LatLng(this.state.lat, this.state.lng);

    mapOptions = {
      zoom: 14,
      center: myLatlng,
      mapTypeId: window.google.maps.MapTypeId.ROADMAP
    };

    var map = new window.google.maps.Map(
      document.getElementById("map"),
      mapOptions
    );
    var marker = new window.google.maps.Marker({
      position: myLatlng,
      map: map,
      draggable: true,
       icon: toAbsoluteUrl("/media/logos/gowatr_marker.png"),
      title: "Location"
    });
    marker.setMap(map);
    var latt;
    var long;
    window.google.maps.event.addListener(
      marker,
      "dragend",
      function (event) {
        latt = event.latLng.lat();
        long = event.latLng.lng();

        //   this.setGeoCode(event.latLng.lat(), event.latLng.lng());
        this.setState({ lat: latt, lng: long });
        this.getReverseGeoCoding(latt, long)
      }.bind(this)
    );
  };

  render() {
    return (
      <div>
        {/* <p>GeoCoding</p> */}
        {/* <input
          type="text"
          value={this.state.address}
          onChange={this.addressInputHandler.bind(this)}
        />
        <button onClick={this.getGeoCoding.bind(this, this.state.address)}>
          Submit
        </button> */}
        {/* {this.props.address} */}
        <div id="map"></div>
      </div>
    );
  }
}

function loadScript(url) {
  var index = window.document.getElementsByTagName("script")[0];
  var script = window.document.createElement("script");
  script.src = url;
  script.async = true;
  script.defer = true;
  index.parentNode.insertBefore(script, index);
}

export default GeoCoding;
